import { render, staticRenderFns } from "./wechatSet.vue?vue&type=template&id=61c0c4ea&scoped=true&"
import script from "./wechatSet.vue?vue&type=script&lang=js&"
export * from "./wechatSet.vue?vue&type=script&lang=js&"
import style0 from "./wechatSet.vue?vue&type=style&index=0&id=61c0c4ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0c4ea",
  null
  
)

export default component.exports